import type { TEventReferencePreview, TReferencePreview } from '@vlabs/monokit/entities/matcher/types/types';

import { EventPreview } from './event-preview/EventPreview';
import { FacePreview } from './face-preview/FacePreview';

export interface ReferencePreviewProps {
  reference: TReferencePreview;
  eventPreview?: (props: { reference: TEventReferencePreview }) => JSX.Element;
}

export function ReferencePreview({
  reference,
  eventPreview = EventPreview,
}: ReferencePreviewProps): JSX.Element {
  switch (reference.type) {
    case 'face':
    case 'face_external_id':
      return <FacePreview reference={reference} />;
    case 'event':
      return eventPreview({ reference });
    default:
      return <div>Preview not available</div>;
  }
}
